export const sports: { name: string; id: number }[] = [
  { name: 'Basketball', id: 1 },
  { name: 'Football', id: 2 },
  { name: 'Tennis', id: 3 },
  { name: 'Baseball', id: 4 },
  { name: 'Soccer', id: 5 },
  { name: 'Golf', id: 6 },
  { name: 'Volleyball', id: 7 },
  { name: 'Swimming', id: 8 },
  { name: 'Track & Field', id: 9 },
  { name: 'Cross Country', id: 10 },
  { name: 'Field Hockey', id: 11 },
  { name: 'Bowling', id: 12 },
  { name: 'Fencing', id: 13 },
  { name: 'Gymnastics', id: 14 },
  { name: 'Ice Hockey', id: 15 },
  { name: 'Rifle', id: 16 },
  { name: 'Skiing', id: 17 },
  { name: 'Diving', id: 18 },
  { name: 'Wrestling', id: 19 },
  { name: 'Beach Volleyball', id: 20 },
  { name: 'Lacrosse', id: 21 },
  { name: 'Rowing', id: 22 },
  { name: 'Softball', id: 23 },
  { name: 'Water Polo', id: 24 },
]

export const interestSuggestions: string[] = [
  'Sports Marketing',
  'Fashion',
  'Fitness',
  'Technology',
  'Food & Beverage',
  'Travel',
  'Gaming',
  'Automotive',
  'Entertainment',
]

export const contentStyleSuggestions: string[] = [
  'Tutorial',
  'Day in the Life',
  'Behind the Scenes',
  'Product Review',
  'Interview',
  'Challenge',
  'Reaction',
  'Q&A',
]

export const brandCategorySuggestions: string[] = [
  'Sportswear',
  'Health & Wellness',
  'Food & Beverage',
  'Tech Gadgets',
  'Fitness Equipment',
  'Luxury',
  'Automotive',
  'Fashion',
  'Lifestyle',
]

export const excludedCategorySuggestions: string[] = [
  'Alcohol',
  'Gambling',
  'Tobacco',
  'Adult Content',
  'Political',
  'Controversial Products',
  'Fast Food',
  'Firearms',
]

export const ADTHLETE_LOGO_SQUARE_URL =
  'https://adthlete.us-iad-1.linodeobjects.com/public/adthlete_logomark.png'
